import styles from './AnalyticsActions.module.scss';

import classNames from 'classnames';
import React, { useState } from 'react';

import {
  useCreateTrackingLinkCommand,
  useExportEventAnalytics
} from 'legacy/events/hooks';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import TrackingLinkForm from '../tracking-link/TrackingLinkForm';
import { saveAs } from 'file-saver';

type AnalyticsActionsProps = {
  eventId: string;
};

const AnalyticsActions: React.FC<AnalyticsActionsProps> = ({ eventId }) => {
  const createTrackingLinkCommand = useCreateTrackingLinkCommand();

  const { refetch: fetchExcelData, isLoading } = useExportEventAnalytics(
    eventId,
    {
      isEnabled: false
    }
  );

  const onDownloadExcelSheet = async () => {
    const { data: rawData } = await fetchExcelData();
    const blob = new Blob([rawData], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
    });

    saveAs(blob, 'Bounce-Event-Analytics.xlsx');
  };

  const [shouldShowTrackingLinkForm, setShouldShowTrackingLinkForm] =
    useState(false);

  const openTrackingLinkForm = () => {
    setShouldShowTrackingLinkForm(true);
  };

  const closeTrackingLinkForm = () => {
    setShouldShowTrackingLinkForm(false);
    createTrackingLinkCommand.reset();
  };

  return (
    <>
      <div
        className={classNames(
          'w-full bg-white fixed bottom-0 left-0 p-4 z-10 pb-12',
          styles.shadow
        )}
      >
        <div className="w-full md:w-[630px] mx-auto">
          <div className="md:flex gap-4 w-full">
            <div className="w-full">
              <Button onClick={onDownloadExcelSheet} loading={isLoading}>
                <div className="flex items-center justify-center">
                  Download Excel Sheet
                </div>
              </Button>
            </div>

            <div className="mt-3 md:mt-0 w-full">
              <Button type={ButtonType.Primary} onClick={openTrackingLinkForm}>
                <div className="flex items-center justify-center">
                  Add Tracking Link
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {shouldShowTrackingLinkForm && (
        <TrackingLinkForm
          eventId={eventId}
          onSubmit={(values) => {
            createTrackingLinkCommand.mutate(values, {
              onSuccess: closeTrackingLinkForm
            });
          }}
          onClose={closeTrackingLinkForm}
          isLoading={createTrackingLinkCommand.isLoading}
          errorMessage={createTrackingLinkCommand.error?.message}
        />
      )}
    </>
  );
};

export default AnalyticsActions;
